import * as React from "react";
import {
  Card as ShadcnCard,
  CardHeader,
  CardFooter,
  CardTitle,
  CardDescription,
  CardContent,
  CardBody,
} from "../card";
import { cn } from "@/lib/utils";

export interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  shadow?: "none" | "sm" | "md" | "lg";
  isPressable?: boolean;
  disabled?: boolean;
  radius?: "none" | "sm" | "md" | "lg" | "xl" | "2xl" | "full";
  className?: string;
  classNames?: {
    base?: string;
  };
}

const shadowClassMap: Record<string, string> = {
  none: "shadow-none",
  sm: "shadow-sm",
  md: "shadow-md",
  lg: "shadow-lg",
};

const radiusClassMap: Record<string, string> = {
  none: "rounded-none",
  sm: "rounded-sm",
  md: "rounded-md",
  lg: "rounded-lg",
  xl: "rounded-xl",
  "2xl": "rounded-2xl",
  full: "rounded-full",
};

const Card = React.forwardRef<HTMLDivElement, CardProps>(
  (
    {
      shadow = "none",
      isPressable,
      disabled,
      radius,
      className,
      classNames,
      ...props
    },
    ref
  ) => {
    const shadowClass = shadowClassMap[shadow] ?? "";

    const radiusClass = radiusClassMap[radius ?? "xl"] ?? "";

    return (
      <ShadcnCard
        ref={ref}
        className={cn(
          shadowClass,
          radiusClass,
          isPressable && !disabled && "cursor-pointer",
          disabled && "opacity-50 cursor-not-allowed pointer-events-none",
          classNames?.base,
          className
        )}
        {...props}
      />
    );
  }
);
Card.displayName = "Card";

export {
  Card,
  CardHeader,
  CardFooter,
  CardTitle,
  CardDescription,
  CardContent,
  CardBody,
};
